import { useCallback } from 'react'

import { apiUrl, toQuery, useApiRequest } from '../useApiRequest'

import { CancellationResult } from '../../types/booking/booking'
import { CancelReason } from '../../types/court/court'

/**
 * Cancelling confirmed bookings. What was paid for a booking comes back as refund points; prepaid minutes go back to
 * their passes when the club cancels (customers can only reschedule bookings paid with passes).
 */
export function useBookingActions() {
  const { run, loading, error, resetState } = useApiRequest()

  const cancelOwn = useCallback(
    (bookingId: number) =>
      run(({ poster }) =>
        poster<CancellationResult>(apiUrl(`/bookings/${bookingId}/cancel`), undefined, 'application/json')
      ),
    [run]
  )

  const cancelByManagement = useCallback(
    (bookingId: number, reason: CancelReason) =>
      run(({ poster }) =>
        poster<CancellationResult>(
          apiUrl(`/management/bookings/${bookingId}/cancel${toQuery({ reason })}`),
          undefined,
          'application/json'
        )
      ),
    [run]
  )

  return { cancelOwn, cancelByManagement, loading, error, resetState }
}
